import React from 'react';
import R from 'ramda';
import {compose} from 'recompose';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {setLesson} from 'reducers';

const Form = ({className, intro}) => (
  <form
    name="contact"
    method="post"
    data-netlify="true"
    data-netlify-honeypot="bot-field"
    action="/thanks/"
    className={classNames({
      [className]: className
    })}
  >
    <input type="hidden" name="form-name" value="contact" />
    <div data-netlify-recaptcha="true" />
    <div className="flex mxn1">
      <p className="col-6 px1 my0">
        <label className="label">Your Name</label>
        <input type="text" name="name" className="input" />
      </p>
      <p className="col-6 px1 my0">
        <label className="label">Phone Number</label>
        <input type="tel" name="phone" className="input" />
      </p>
    </div>

    <p className="mt0">
      <label className="label">Your Email</label>
      <input type="email" name="email" className="input" />
    </p>
    <p>
      <label className="label">Message</label>
      <textarea
        name="message"
        className="textarea"
        placeholder={intro}
        style={{
          minHeight: '7.5rem'
        }}
      />
    </p>
    <p className="pt1">
      <button type="submit" className="btn btn-primary">
        Send
      </button>
    </p>
  </form>
);

const enhance = compose(
  connect(
    state => state,
    {
      setLesson
    }
  )
);

export default enhance(Form);



// WEBPACK FOOTER //
// ./src/components/Form.js